import React from 'react';
import { HomeView } from '@/views/HomeView';
import { MainLayout } from '@/widgets/layouts/MainLayout';

export const HomePage = () => (
  <MainLayout headerTitle="Dashboard">
    <HomeView />
  </MainLayout>
);
